<template>
	<sf-data-table
		ref="grpTable"
		index
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:span-method="spanMethod"
		:stripe="false"
		:selection="false"
	>
		<!-- <template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'mmTot'">
				<template v-if="slotProps.row.guBun === '2'">
					<td
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>
			<template v-if="slotProps.column.property === 'qtTot'">
				<template v-if="slotProps.row.guBun === '2'">
					<td
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>

			<template v-if="slotProps.column.property === 'yyTot'">
				<template v-if="slotProps.row.guBun === '2'">
					<td
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>

			<template v-for="(item, index) in monthlabel">
				<template v-if="slotProps.column.property === item">
					<template v-if="slotProps.row.guBun === '2'">
						<td
							:key="index"
							class="col-1"
							style="all: unset; cursor: pointer; text-align: right"
							@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
						>
							{{ slotProps.row[slotProps.column.property] }}
						</td>
					</template>

					<template v-else>
						{{ slotProps.row[slotProps.column.property] }}
					</template>
				</template>
			</template>
		</template> -->
	</sf-data-table>
</template>

<script>
import { setLpad } from '@/qmsUtils/'; //공통함수 import
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmClam/store/helpers';
import PcRoList from '@mqy/clma/PcRoList/PcRoList.vue';
import qmsUtils from '@/store/qms/api'; //변수관리 값 가져오기

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			pcRoListScrId: '' //ro리스트 scrId
		};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList;
		},
		cols() {
			let cols = [];
			let tot = {
				label: this.getMessage_('QWCC001730'), //Total
				align: 'right',
				minWidth: '100px',
				fixed: true,
				sortable: false
			};

			let mmScn = {
				label: this.getMessage_('MWPP000165'), //대분류
				prop: 'mmScn',
				align: 'left',
				minWidth: '120px',
				fixed: true,
				sortable: false
			};
			let scn = {
				label: this.getMessage_('MWPP000167'), //중분류
				prop: 'scn',
				align: 'left',
				minWidth: '120px',
				fixed: true,
				sortable: false
			};
			cols.push(mmScn);
			cols.push(scn);
			cols.push(tot);

			let startMonth = this.searchParams.strtMm01;
			let endMonth = this.searchParams.endMm01;
			let strYr = this.$moment(startMonth).year();
			let strMo = this.$moment(startMonth).month();
			let diffMonth = this.$moment(endMonth).diff(this.$moment(startMonth), 'months');
			let qtVal1 = false;
			let qtVal2 = false;
			let qtVal3 = false;
			let qtVal4 = false;

			if (this.searchParams.mmPrvs === '10') {
				// console.log('getter mmPrvs 변함	::', this.searchParams.mmPrvs);
				tot.prop = 'mmTot';
				tot.labelClassName = 'mmTot';
				tot.clickEvent = row => this.onGoClick(row[tot.prop], row, 'mmTot');

				let propI = 1;
				for (let i = strMo; i < strMo + diffMonth + 1; i++) {
					const year = strYr + Math.floor(i / 12);
					const month = (i % 12) + 1;
					const labelYear = year.toString().substring(2, 4) + this.getMessage_('QWCC001451') + ' ';
					let pclProp = 'mm' + setLpad(propI, 2, '0');
					const newCol = {
						label: labelYear + setLpad(month, 2, '0') + this.getMessage_('SWCC000365'),
						prop: pclProp,
						minWidth: '100px',
						align: 'right',
						clickEvent: row => this.onGoClick(row[pclProp], row, year + setLpad(month, 2, '0')),
						labelClassName: labelYear + setLpad(month, 2, '0')
					};
					propI++;
					cols.push(newCol);
				}
			} else if (this.searchParams.mmPrvs === '20') {
				//let qtVal = this.$moment(startMonth).quarter();

				//let qtqt = Math.floor(diffMonth / 3);

				tot.prop = 'qtTot';
				tot.labelClassName = 'qtTot';
				tot.clickEvent = row => this.onGoClick(row[tot.prop], row, 'qtTot');
				let propI = 1;
				let newCol;
				for (let i = strMo; i < strMo + diffMonth + 1; i++) {
					const year = strYr + Math.floor(i / 12);
					const labelYear = year.toString().substring(2, 4) + this.getMessage_('QWCC001451') + ' ';
					const month = (i % 12) + 1;
					let pclProp = 'qt' + setLpad(propI, 2, '0');

					if (month == 1 || month == 2 || month == 3) {
						if (qtVal1 === false) {
							newCol = {
								label: labelYear + ' 01Qt',
								prop: pclProp,
								minWidth: '100px',
								align: 'right',
								clickEvent: row => this.onGoClick(row[pclProp], row, year.toString().substring(0, 4) + ',01Qt'),
								labelClassName: labelYear + '01Qt'
							};
							cols.push(newCol);
							propI++;
							qtVal1 = true;
						} else {
						}
					} else if (month == 4 || month == 5 || month == 6) {
						if (qtVal2 === false) {
							newCol = {
								label: labelYear + ' 02Qt',
								prop: pclProp,
								minWidth: '100px',
								align: 'right',
								clickEvent: row => this.onGoClick(row[pclProp], row, year.toString().substring(0, 4) + ',02Qt'),
								labelClassName: labelYear + '02Qt'
							};
							cols.push(newCol);
							propI++;
							qtVal2 = true;
						} else {
						}
					} else if (month == 7 || month == 8 || month == 9) {
						if (qtVal3 === false) {
							newCol = {
								label: labelYear + ' 03Qt',
								prop: pclProp,
								minWidth: '100px',
								align: 'right',
								clickEvent: row => this.onGoClick(row[pclProp], row, year.toString().substring(0, 4) + ',03Qt'),
								labelClassName: labelYear + '03Qt'
							};
							cols.push(newCol);
							propI++;
							qtVal3 = true;
						} else {
						}
					} else if (month == 10 || month == 11) {
						if (qtVal4 === false) {
							newCol = {
								label: labelYear + ' 04Qt',
								prop: pclProp,
								minWidth: '100px',
								align: 'right',
								clickEvent: row => this.onGoClick(row[pclProp], row, year.toString().substring(0, 4) + ',04Qt'),
								labelClassName: labelYear + '04Qt'
							};
							cols.push(newCol);
							propI++;
							qtVal4 = true;
						} else {
						}
					} else if (month == 12) {
						if (qtVal4 === false) {
							newCol = {
								label: labelYear + ' 04Qt',
								prop: pclProp,
								minWidth: '100px',
								align: 'right',
								clickEvent: row => this.onGoClick(row[pclProp], row, year.toString().substring(0, 4) + ',04Qt'),
								labelClassName: labelYear + '04Qt'
							};
							cols.push(newCol);
							propI++;
						} else {
						}
						qtVal1 = false;
						qtVal2 = false;
						qtVal3 = false;
						qtVal4 = false;
					}
				}
			} else {
				tot.prop = 'yyTot';
				tot.labelClassName = 'yyTot';
				tot.clickEvent = row => this.onGoClick(row[tot.prop], row, 'yyTot');
				let endYr = this.$moment(endMonth).year();
				let diffYears = this.$moment(endYr).diff(strYr);
				let propI = 1;
				for (let i = strYr; i < strYr + diffYears + 1; i++) {
					const labelYear = i + this.getMessage_('QWCC001451');
					const labelYear2 = i;
					//console.log('labelYear	::', labelYear);
					let pclProp = 'yy' + setLpad(propI, 2, '0');
					//console.log('dddd', pclProp);
					const newCol = {
						label: labelYear,
						prop: pclProp,
						minWidth: '100px',
						align: 'right',
						clickEvent: row => this.onGoClick(row[pclProp], row, labelYear2),
						labelClassName: labelYear
					};
					propI++;
					cols.push(newCol);
				}
			}

			return cols;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				if (rowIndex === 0) {
					return {
						rowspan: 1,
						colspan: 1
					};
				} else if (rowIndex == 1) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else if (rowIndex == 2 || rowIndex == 3) {
					return {
						rowspan: 0,
						colspan: 0
					};
				} else {
					return {
						rowspan: 1,
						colspan: 1
					};
				}
			}
		},
		async onGoClick(argsCnt, rowsInfo, labelClassName) {
			let selCnt = argsCnt;

			// console.log('selCnt:-------', selCnt);
			//값이 없을땐 이동을 못함.
			if (selCnt == 0 || selCnt == '') {
				return false;
			}

			const roScrId = await qmsUtils.getVariableValue('pcRoListScrId');

			this.pcRoListScrId = roScrId.varVal;

			//대상대수
			let name = ''; //R/O리스트
			let selScrId = ''; //스크린 ID
			let selMsgKey = '';
			let selComponent = '';

			let pStartDt = ''; //판매월시작일자
			let pEndDt = ''; //판매월종료일자
			let pStartDt2 = ''; //조건월시작일자
			let pEndDt2 = ''; //조건월종료일자

			let pState1 = this.searchParams.partG || ''; // 부품유형
			let pState2 = this.searchParams.carScn || ''; // 차량구분
			let pState3 = this.searchParams.pacScn || ''; // 승상구분
			let pState4 = this.searchParams.flclSpc || ''; // 연료전지사양
			let pState5 = this.searchParams.occuRegn || ''; // 판매지역
			let pState6 = this.searchParams.idxScn || ''; // 사용기간(3m,12m,WM)
			let pState7 = this.pState7 || ''; //RO처리단계
			let pState8 = this.pState8 || ''; //RO처리결과
			let pState9 = this.searchParams.ctype || ''; //Ctype
			let pState10 = this.searchParams.carTypeNm || ''; //차종유형
			let pState11 = this.searchParams.srchMm01 || ''; //판매월 검색조건
			let pState12 = this.searchParams.srchMm02 || ''; //조건월 검색조건
			let pState13 = this.searchParams.useTerm || ''; //사용기간(년)
			let pState14 = this.searchParams.idxScn || ''; //지수구분
			let pState15 = this.searchParams.phmnCd || ''; //현상코드
			let pState16 = this.searchParams.check || ''; //누적
			let pState17 = this.searchParams.partNo || ''; //품번
			let pState18 = '10' || ''; //정비유형

			let baseYyyy = this.searchParams.searchDate; //검색하는 기준년도

			let tmpYear = this.$moment(baseYyyy + '0101')
				.subtract(1, 'years')
				.format('YYYYMMDD');

			if (rowsInfo.guBun == '2') {
				if (this.searchParams.mmPrvs == '10') {
					if (labelClassName == 'mmTot') {
						pStartDt = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD'); //판매월 시작일자
						pEndDt = this.$moment(this.searchParams.endMm01).format('YYYYMMDD'); //판매월 종료일자
						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
					} else {
						pStartDt = this.$moment(labelClassName + '01').startOf('month').format('YYYYMMDD'); //시작일자
						pEndDt = this.$moment(labelClassName + '01').endOf('month').format('YYYYMMDD'); //종료일자
						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
					}
				} else if (this.searchParams.mmPrvs == '20') {
					if (labelClassName == 'qtTot') {
						pStartDt = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD'); //판매월 시작일자
						pEndDt = this.$moment(this.searchParams.endMm01).format('YYYYMMDD'); //판매월 종료일자
						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
						//console.log('qtTot');
					} else {
						let selCol = labelClassName.split(',');

						let selYyyy = selCol[0];
						let selMm = selCol[1];

						if (selMm == '01Qt') {
							pStartDt = selYyyy + '0101'; //판매월 시작일자
							pEndDt = this.$moment(selYyyy + '0301')
								.endOf('month')
								.format('YYYYMMDD');
						} else if (selMm == '02Qt') {
							pStartDt = selYyyy + '0401'; //판매월 시작일자
							pEndDt = this.$moment(selYyyy + '0601')
								.endOf('month')
								.format('YYYYMMDD');
						} else if (selMm == '03Qt') {
							pStartDt = selYyyy + '0701'; //판매월 시작일자
							pEndDt = this.$moment(selYyyy + '0901')
								.endOf('month')
								.format('YYYYMMDD');
						} else {
							pStartDt = selYyyy + '1001'; //판매월 시작일자
							pEndDt = this.$moment(selYyyy + '1201')
								.endOf('month')
								.format('YYYYMMDD');
						}

						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
					}
				} else if (this.searchParams.mmPrvs == '30') {
					if (labelClassName == 'yyTot') {
						pStartDt = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD'); //판매월 시작일자
						pEndDt = this.$moment(this.searchParams.endMm01).format('YYYYMMDD'); //판매월 종료일자
						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
					} else {
						pStartDt = labelClassName + '0101'; //판매월 시작일자
						pEndDt = labelClassName + '1231'; //판매월 종료일자
						pStartDt2 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD'); //조건월 시작일자
						pEndDt2 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD'); //조건월 종료일자
					}
				}else{
					return false;
				}

				name = this.getMessage_('QWCC001590'); //R/O리스트
				selScrId = this.pcRoListScrId; //RO리스트조회
				selMsgKey = 'QWCC001590'; //R/O리스트
				selComponent = PcRoList; //R/O리스트 Vue 파일
			}else{
				return false;
			}

			let item = {
				name,
				component: selComponent, //import할 컴포넌트 이름
				scrId: selScrId, //이동할 scr
				msgKey: selMsgKey //R/O리스트
			};

			//console.log('item', item);

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, {
				scrId: item.scrId,
				pStartDt,
				pEndDt,
				pStartDt2,
				pEndDt2,
				pState1,
				pState2,
				pState3,
				pState4,
				pState5,
				pState6,
				pState7,
				pState8,
				pState9,
				pState10,
				pState11,
				pState12,
				pState13,
				pState14,
				pState15,
				pState16,
				pState17,
				pState18
			});
		}
	}
};
</script>

<style></style>
